var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-progress-linear', {
    staticClass: "absolute bottom",
    attrs: {
      "active": _vm.loader,
      "indeterminate": _vm.loader,
      "height": "4",
      "color": "deep-purple accent-4"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }